<template>
  <div>
    <h1>Destinos</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar destino"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-table
        show-empty
        stacked="md"
        :items="getAllDestinations"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        emptyFilteredText="No existen registros por mostrar"
        empty-text="No existen registros por mostrar">
        <template v-slot:cell(acciones)="row">
          <router-link size="sm" :to="{name:'EditDestination', params: row.item}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>
          <b-button class="btn-sm" variant="outline-danger"  @click="showDeleteDestinationModal(row.item)">Eliminar</b-button>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllDestinations.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { Modal } from 'ant-design-vue'
import headers from '@/config/headers.js'
const GET_ALL_DESTINATIONS = gql`
  query getAllDestinations{
    getAllDestinations{
      id
      name
      createdBy
    }
  }
`
const DELETE_DESTINATION = gql`
mutation deleteDestination($destinationId: Int){
  deleteDestination(destinationId: $destinationId){
    success
    message
  }
}
`
export default {
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Nombre del destino' },
        { key: 'createdBy', label: 'Creado por' },
        'acciones',
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      getAllDestinations: [],
    }
  },
  apollo: {
    getAllDestinations: {
      query: GET_ALL_DESTINATIONS,
      result({ data }) {
        this.totalRows = data.getAllDestinations.length
      },
      error(err) {
        console.log(err)
      },
      context: headers(),
    },
  },
  methods: {
    deleteDestination(destination) {
      this.$apollo.mutate({
        mutation: DELETE_DESTINATION,
        variables: {
          destinationId: parseInt(destination.id),
        },
        context: headers(),
      })
        .then(data => {
          console.log(data)
          this.$apollo.queries.getAllDestinations.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteDestinationModal(destination) {
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas eliminar el destino ${destination.name}?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.deleteDestination(destination)
        },
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
